import "./DrSharmatProfile.module.css";
import Header from "@/reusable_sections/Header";
import DrSamuelLSharmatFullProfile from "./sections/DrSamuelLSharmatFullProfile";
import Footer from "@/reusable_sections/Footer";
export default function DrSharmatProfilePage() {
  return <div>
      <Header />
      <DrSamuelLSharmatFullProfile />
      <Footer />
    </div>;
}